import pixAxios from '@/axios/pixAxios.js';
import Console from '@/shared/console';

const personasModule = {
  namespaced: true,
  state: {
    attributes: null,
    rowPersonasId: '',
    personaDetail: null,
  },
  actions: {
    async loadAttributes({ state, commit }) {
      if (!state.attributes) {
        const { data } = await pixAxios.get('/api/Persona/GetPersonasMasterListAttributes');
        commit('setAttributes', data);
      }
    },

    setPersonasRowId({ state, commit }, rowPersonasId) {
      commit('setPersonasRowId', rowPersonasId);
    },

    async setPersonasDetail({ state, commit }) {
      commit('setPersonasDetail', null);
      try {
        const { data } = await pixAxios.get(`/api/Persona/GetPersona?RowID=${state.rowPersonasId}`);
        commit('setPersonasDetail', data);
      } catch (error) {
        // eslint-disable-next-line
        Console.log(error.response);
      }
    },
  },

  mutations: {
    setAttributes(state, attributes) {
      state.attributes = attributes;
    },

    setPersonasRowId(state, rowPersonasId) {
      state.rowPersonasId = rowPersonasId;
    },

    setPersonasDetail(state, detail) {
      state.personaDetail = detail;
    },
  },

  getters: {
    getAttributes(state) {
      return state.attributes;
    },

    getPersonasRowId(state) {
      return state.rowPersonasId;
    },

    getPersonaDetail(state) {
      return state.personaDetail;
    },
  },
};

export default personasModule;
